import { cn } from '~/lib/cn';

export const STICKY_TABLE_HEADER_CLASS = cn(
  // Calculation for "top" = var(--sticky-header-height) + border-spacing-y-sm
  'sticky top-[calc(var(--sticky-header-height)+var(--spacing-sm))] z-10 will-change-[top]',
);

export const SCROLL_COLLAPSE_EASING_DURATION_CLASS = 'duration-300 ease-out';
